export const LSKeys = {
  edsooAccessToken: "edsooAccessToken",
};